import Crud from '../components/MaterialCategory/Crud'
import Add from '../components/MaterialCategory/Add'
import Edit from '../components/MaterialCategory/Edit'

let routes = {
    path: '/materialCategory',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/materialCategory',
            component: Crud
        },
        {
            path: '/materialCategory/add',
            component: Add
        },
        {
            path: '/materialCategory/edit/:id',
            component: Edit
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/materialCategory.js